module.exports = __webpack_public_path__ + "img/logo-white.fb128d90.png";